/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const InventoryProductDetailPage = lazyLoad(
  () => import('./index'),
  module => module.InventoryProductDetailPage
);
